/**
 * Der Einstieg: ohne Sitzung die Pforte, mit Sitzung die Akte.
 */
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { SitzungsProvider, useSitzung } from './api/sitzung.js'
import { Layout } from './bausteine/Layout.js'
import { Dashboard } from './screens/Dashboard.js'
import { Feedback } from './screens/Feedback.js'
import { EventDetail } from './screens/EventDetail.js'
import { Gesetzbuch } from './screens/Gesetzbuch.js'
import { HallOfShame } from './screens/HallOfShame.js'
import { Konto } from './screens/Konto.js'
import { Pforte } from './screens/Pforte.js'
import { Termine, TerminAnsetzen } from './screens/Termine.js'
import { Verwaltung } from './screens/Verwaltung.js'

function Innen() {
  const { mitglied } = useSitzung()
  if (!mitglied) return <Pforte />

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path="/termine" element={<Termine />} />
        <Route path="/termine/neu" element={<TerminAnsetzen />} />
        <Route path="/termine/:id" element={<EventDetail />} />
        <Route path="/konto" element={<Konto />} />
        <Route path="/konto/:memberId" element={<Konto />} />
        <Route path="/schande" element={<HallOfShame />} />
        <Route path="/gesetz" element={<Gesetzbuch />} />
        <Route path="/feedback" element={<Feedback />} />
        <Route path="/verwaltung" element={<Verwaltung />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  )
}

export function App() {
  return (
    <BrowserRouter>
      <SitzungsProvider>
        <Innen />
      </SitzungsProvider>
    </BrowserRouter>
  )
}
